import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit, faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../../store/hooks';
import {
  deleteEnquiryAttachmentThunk,
  getEnquiryAttachmentByIdThunk,
} from '../../../../../../store/thunks/enquiry/attachmentsThunks';
import { AttachmentsCellProps } from '../../../../../../core/types/coreTypes';
import ConfirmationModal from '../../../../../../core/components/confirmation-modal/ConfirmationModal';
import usePermission from '../../../../../../permissions-handling/permissionHook';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import AttachmentsRow from '../../../../../../common/components/attachments-table/AttachmentsRow';

const EnquiryAttachmentCell: React.FC<AttachmentsCellProps> = ({
  attach,
  openEditModal,
  checked,
  checkRow,
}) => {
  const { id } = useParams();
  const allowedManage = usePermission(PermissionEnum.EnquiryEditFields);

  const dispatch = useAppDispatch();
  const [isModal, setModal] = useState<boolean>(false);
  const actions = [
    {
      label: 'Edit comment',
      icon: <FontAwesomeIcon icon={faEdit} />,
      key: 'editComment',
      onClick: () => openEditModal(),
    },
    {
      label: 'Delete file',
      key: 'deleteFile',
      icon: <FontAwesomeIcon icon={faTrashAlt} />,
      onClick: () => setModal(true),
    },
  ];
  return (
    <>
      <ConfirmationModal
        isVisible={isModal}
        onCancel={() => setModal(false)}
        confirmHandler={() => id && dispatch(deleteEnquiryAttachmentThunk({
          attachmentId: attach.id,
          enquiryId: +id,
          closeModal: () => setModal(false),
        }))}
      />
      <AttachmentsRow
        allowedManage={!!allowedManage}
        attachment={attach}
        checked={checked}
        checkRows={checkRow}
        onClick={(attachmentId) => id && dispatch(getEnquiryAttachmentByIdThunk({
          enquiryId: +id,
          attachmentId,
        }))}
        actions={actions}
      />
    </>
  );
};

export default EnquiryAttachmentCell;
